module.exports = __webpack_public_path__ + "img/4.b8446936.png";